import React__default, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { AutoshipmentLogoLockup, P1 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import { MiniSummary } from '../../common/mini-summary/MiniSummary.js';
import styles from './CartError.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const CartError = (props) => {
    const { site, locale } = useSiteContext();
    const { t } = useTranslation(site.realm);
    const offerRef = useRef(null);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: styles.wrapper, "data-testid": "error-box", ref: offerRef },
            React__default.createElement("div", { className: styles.errorTitle, "data-testid": "quest-error-title" },
                React__default.createElement(AutoshipmentLogoLockup, { size: 'medium', locale: locale, realm: site.realm }),
                React__default.createElement(P1, { className: styles.text }, props.guestAccount
                    ? t('checkout.guest-error.text')
                    : props.paymentError && t('checkout.payment-error.text')))),
        props.stickySection &&
            !props.guestAccount &&
            props.paymentError &&
            createPortal(React__default.createElement(MiniSummary, { offerElement: offerRef.current, errorTranslation: t('checkout.payment-error.mini-summary-text'), cta: "cart" }), props.stickySection)));
};

export { CartError };
//# sourceMappingURL=CartError.js.map
